import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import React from 'react';
import { palette, remCalc } from '../../css';
import RocketBase from '../Icon/Rocket';

const Container = styled('div')({
    display: 'flex',
    width: '100%',
});
const Wrapper = styled('div')({
    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    color: palette('grey', 'base'),
    justifyContent: 'center',
});

const RocketIcon = styled(RocketBase)({
    margin: 'auto',
    paddingBottom: remCalc(10),
});

const NoResult = ({ suggestions, suggestionLabel, noResultLabel }) => (
    <Container>
        <Wrapper>
            <RocketIcon name="arte-rocket" size="xxlarge" />
            {noResultLabel && <p>{noResultLabel}</p>}
            {suggestionLabel && <p>{suggestionLabel}</p>}
            <ul>
                {suggestions.map((suggestion, index) => (
                    // ? we assume to use the index, because the content of this section shoudn't be dynamic
                    // eslint-disable-next-line react/no-array-index-key
                    <li key={`suggestion_${index}`}>{suggestion}</li>
                ))}
            </ul>
        </Wrapper>
    </Container>
);

NoResult.propTypes = {
    noResultLabel: PropTypes.string,
    suggestionLabel: PropTypes.string,
    suggestions: PropTypes.arrayOf(PropTypes.element),
};

NoResult.defaultProps = {
    suggestions: [],
    noResultLabel: null,
    suggestionLabel: null,
};

export default NoResult;
